import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'start',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'start',
        loadChildren: './start/start.module#StartModule'
      },
      {
        path: 'spanish',
        loadChildren: './Qspanish/spanish-questions.module#SpanishModule',
      },
      {
        path: 'english',
        loadChildren: './QEnglish/english-questions.module#EnglishModule',
      },
      {
        path: 'questionsmath',
        loadChildren: './QMath/math-questions.module#QuestionsMathModule',
      },
      {
        path: 'english-results',
        loadChildren: './REnglish/english-results.module#EnglishResultsModule',
      },
      {
        path: 'spanish-results',
        loadChildren: './Rspanish/spanish-results.module#SpanishResultsModule',
      },
      {
        path: 'math-results',
        loadChildren: './RMath/math-results.module#RMathModule',
      }

    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts